import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useGetPoolOptions } from './utils/useGetPoolOptions';

import { Skeleton } from '@mui/lab';
import Grid from '@mui/material/Grid';

import { ControlledAutoComplete } from 'components/shared';

export const PoolDropdown = ({
  name
}: {
  name: 'employeePool' | 'requestPool';
}) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { isFetching, data } = useGetPoolOptions();

  return (
    <>
      {isFetching ? (
        <>
          <Skeleton />
        </>
      ) : (
        <Grid container spacing={2}>
          <Grid item sx={{ width: '100%' }}>
            <ControlledAutoComplete
              fullWidth
              idProperty="value"
              optionLabelProp="label"
              variant="outlined"
              label={t(name)}
              name={name}
              options={data}
              control={control}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};
